export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7356.5ce9701d.jpg";